import { get, isEmpty } from 'lodash';
import moment from 'moment';

export default function buildResponses(survey) {
  const responses = [];
  Object.keys(survey.data).forEach((key) => {
    let value = survey.data[key];
    const questionModel = survey.getQuestionByValueName(key);
    if (!isEmpty(questionModel)) {
      const title = questionModel.title;

      let displayValue = value.toString();
      let valuesId = [];
      // Array of elements
      if (!isEmpty(questionModel.choices)) {
        if (!Array.isArray(value)) {
          value = [value];
        }

        if (Array.isArray(value)) {
          const choicesText = [];
          value.forEach((v) => {
            const choice = questionModel.choices.find((c) => c.value === v);
            choicesText.push(choice.text);
            if (choice.uuid) {
              valuesId.push(choice.uuid);
            }
          });
          displayValue = choicesText.join(', ');
        }
      }

      if (questionModel.inputType === 'date') {
        displayValue = moment(value).format('MM/DD/YYYY');
      }

      responses.push({
        id: questionModel.uuid || null,
        name: key,
        title,
        valueId: isEmpty(valuesId) ? null : valuesId,
        value: value.toString(),
        displayValue,
      });
    }
  });

  return responses;
}
